<ng-container *ngIf="type === 'page'">
<section class="generic-information-template {{additionalClasses}}">
  <div class="row header">
    <div class="col">
        <div class="header-container">
          <img src="{{headerImageURL}}" alt="Header">
        </div>
    </div>
  </div>
  
  <div class="row margin-vertical mv24">
    <div class="col">
      <mapfre-button
        additionalClasses="link-button blue-link small top-information"
        [customIcon]="'assets/img/icons/back-arrow.png'"
        [iconClasses]="'align-middle'"
        [routerLink]="[backButtonUrl]"
        [showIconsCustom]="true"
      >  {{ 'BACK' | translate }}
      </mapfre-button>
    </div>
  </div>
  
  <div class="row margin-bottom mb24">
    <div class="col">
        <ng-content></ng-content>
    </div>
  </div>
  
  <div class="row text-center">
    <div class="col">
      <mapfre-button
        additionalClasses="link-button blue-link small"
        [customIcon]="'assets/img/icons/back-arrow.png'"
        [iconClasses]="'align-middle'"
        [routerLink]="[backButtonUrl]"
        [showIconsCustom]="true"
      >  {{ 'BACK' | translate }}
      </mapfre-button>
    </div>
  </div>
</section>
</ng-container>

<ng-container *ngIf="type === 'list'">
    <div class="informaton-container">
        <div class="row text-center">
          <div class="col"> 
            <div class="header-icon full-icon">
                <svg-information-color-svg></svg-information-color-svg>
            </div>
            <h1 class="title-copy">{{ 'INFORMATION' | translate }}</h1> 
          </div>
        </div>
      
     
      </div>
</ng-container>